<div class="footer-bg-shape">
  <div class="login-footer">
    <p>{{ 'copyRights' | translate | uppercase }} &copy; <a href="#" class="developer">SmartTech</a> 2023</p>
  </div>
</div>
